import type { ViewerPreferenceSettings } from './viewer-preference-types';

export type ViewerPreferenceInput = ViewerPreferenceSettings;

export interface ViewerPreferenceWritableSettings {
  background: unknown;
  color: unknown;
  materialPhong: unknown;
  clippingHighlightColor: unknown;
}

export interface ViewerPreferenceMaterialPhong {
  readonly dark: unknown;
  readonly default: unknown;
}

function getColorConstructor(
  existingColor: unknown
): new (hex: string) => unknown {
  return (existingColor as { constructor: new (hex: string) => unknown })
    .constructor;
}

export function createSettingsColorFromHex<T>(
  existingColor: unknown,
  hex: string
): T {
  const Color = getColorConstructor(existingColor);
  return new Color(hex) as T;
}

export function applyViewerPreferences(
  settings: ViewerPreferenceWritableSettings,
  preferences: ViewerPreferenceInput,
  materialPhong: ViewerPreferenceMaterialPhong
): void {
  const Color = getColorConstructor(settings.color);

  settings.background = {
    topColor: new Color(preferences.backgroundTopColor),
    bottomColor: new Color(preferences.backgroundBottomColor),
  };
  settings.color = new Color(preferences.textColor);
  settings.materialPhong = preferences.darkModeMaterials
    ? materialPhong.dark
    : materialPhong.default;
  settings.clippingHighlightColor = createSettingsColorFromHex(
    settings.color,
    preferences.clippingHighlightColor
  );
}
